import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { BalancesMessagingConstants } from '../../core/constants/messaging.constants';
import { UserSessionService } from '../../core/services/user-session.service';

// Splits the warning around its link so the anchor can be a real RouterLink in the template.
const LINK_PLACEHOLDER = '{stripeSetupLink}';

@Component({
  selector: 'ms-stripe-setup-notice',
  imports: [FontAwesomeModule, RouterLink],
  templateUrl: './stripe-setup-notice.component.html'
})
export class StripeSetupNoticeComponent {

  private userSessionService = inject(UserSessionService);

  public linkText = BalancesMessagingConstants.PROPERTY_CHARGE_SCHEDULE_STRIPE_WARNING_LINK_TEXT();

  // A stable reference, so [queryParams] does not see a new object on every change detection pass.
  public readonly settingsQueryParams = { tab: 'settings', subtab: 'stripe-onboarding' };

  // Withheld until the settings arrive so a connected organization never flashes the note, and
  // withheld again if they fail to load — a false alarm reads as "Stripe is broken".
  public showNotice = computed<boolean>(() => {
    const settings = this.userSessionService.activeOrganizationSettings();
    return settings !== undefined && !settings.isStripeOnboardingComplete;
  });

  public settingsRoute = computed<unknown[]>(() =>
    ['/organizations/profile', this.userSessionService.activeOrganizationId()]);

  public messageBeforeLink = computed<string>(() => this.messageParts()[0]);
  public messageAfterLink = computed<string>(() => this.messageParts()[1]);

  private messageParts = computed<[string, string]>(() => {
    const [before, after] = BalancesMessagingConstants.PROPERTY_CHARGE_SCHEDULE_STRIPE_WARNING()
      .split(LINK_PLACEHOLDER);

    return [before ?? '', after ?? ''];
  });

  constructor() {
    // Self-contained, so dropping the notice onto a page that never asks for settings still
    // resolves the flag. Repeat calls are deduplicated by the session service.
    void this.userSessionService.getOrganizationSettings();
  }
}
